import { reduxForm } from 'redux-form';
import Component from './FormReason';
import validate from './validate';

export default reduxForm({
  form: 'reason',
  initialValues: {
    reason: '',
  },
  validate
})(Component);
